import { useEffect } from 'react';
import type { BusinessPageData, TemplateTheme } from '@/types';
import { useAnalytics } from '@/hooks/useAnalytics';
import { ModernRetailLayout } from './layouts/ModernRetailLayout';

const LAYOUT_REGISTRY: Record<
  string,
  React.ComponentType<{ business: BusinessPageData; theme: TemplateTheme }>
> = {
  'modern-retail-v2': ModernRetailLayout,
  'modern-retail': ModernRetailLayout,
};

const DEFAULT_THEME: TemplateTheme = {
  primaryColor: '#2563eb',
  secondaryColor: '#1e40af',
  accentColor: '#f59e0b',
  fontFamily: 'Inter',
  headingFont: 'Poppins',
};

interface BusinessPageProps {
  business: BusinessPageData;
}

export function BusinessPage({ business }: BusinessPageProps) {
  const { track } = useAnalytics(business.id);

  useEffect(() => {
    document.title = `${business.name} | QRBusiness India`;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        business.tagline ?? business.description ?? `Visit ${business.name} on QRBusiness India`,
      );
    }
  }, [business]);

  const template = business.template;
  const theme = { ...DEFAULT_THEME, ...(template?.theme ?? {}) };
  const layoutSlug = template?.slug ?? 'modern-retail-v2';
  const Layout = LAYOUT_REGISTRY[layoutSlug] ?? ModernRetailLayout;

  return (
    <div onClick={() => track('click')} role="presentation">
      <Layout business={business} theme={theme} />
    </div>
  );
}
